__turbopack_context__.v({
  "buttonWrapper": "_4KtgLq_buttonWrapper",
  "hintText": "_4KtgLq_hintText",
  "lineItem": "_4KtgLq_lineItem",
  "lineItemLabel": "_4KtgLq_lineItemLabel",
  "lineItemPrice": "_4KtgLq_lineItemPrice",
  "productTitle": "_4KtgLq_productTitle",
  "strikethroughPrice": "_4KtgLq_strikethroughPrice",
  "summaryContainer": "_4KtgLq_summaryContainer",
  "summaryContent": "_4KtgLq_summaryContent",
  "totalContainer": "_4KtgLq_totalContainer",
});
